import React from 'react';
import {Field} from 'redux-form/immutable';
import {SelectField} from 'redux-form-antd'
import {
    required,
    nullValue1
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const SseFamilyAir = props => {
    const ans = '家庭氣氛'
    const select_arr = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '很和諧'
        },
        {
            value: '2',
            label: '和諧'
        },
        {
            value: '3',
            label: '普通'
        },
        {
            value: '4',
            label: '不和諧'
        },
        {
            value: '5',
            label: '很不和諧'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label={ans}
                   options={select_arr} name="sse_family_air" type="text"></Field>
        </div>
    )
}

export default SseFamilyAir


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseFamilyAir.jsx